// extracted by mini-css-extract-plugin
export default {"label":"FormControls_label__Kk2u0","validationMessage":"FormControls_validationMessage__IawJS","input":"FormControls_input__azPxD","textarea":"FormControls_textarea__HuXeN"};